/**
 * DraftPreviewStore
 *
 * Stores draft preview Blob in IndexedDB.
 * Persists across page reload and browser restart until explicitly deleted.
 *
 * Record schema:
 *   { key: string, blob: Blob, mime: string, createdAt: number, updatedAt: number }
 */

import {STORAGE_KEYS} from '../constants/storageKeys'
import {IndexedDBAdapter} from './IndexedDBAdapter'

const adapter = IndexedDBAdapter({
    dbName: STORAGE_KEYS.DRAFT_DB_NAME,
    storeName: STORAGE_KEYS.DRAFT_DB_STORE,
    dbVersion: STORAGE_KEYS.DRAFT_DB_VERSION,
    allStoreNames: STORAGE_KEYS.DRAFT_DB_STORES,
})

const DraftPreviewStore = {
    /**
     * Save a preview Blob under the given key.
     * @param {string} key
     * @param {Blob} blob
     * @returns {Promise<void>}
     */
    async save(key, blob) {
        const now = Date.now()
        await adapter.save(key, {blob, mime: 'image/png', createdAt: now, updatedAt: now})
    },

    /**
     * Load a preview record by key.
     * @param {string} key
     * @returns {Promise<{ key: string, blob: Blob, mime: string, createdAt: number, updatedAt: number } | null>}
     */
    async load(key) {
        return adapter.load(key)
    },

    /**
     * Delete a preview record by key.
     * @param {string} key
     * @returns {Promise<void>}
     */
    async delete(key) {
        return adapter.delete(key)
    },
}

export default DraftPreviewStore
